import React from "react";
import Card from "../../bosch-react/components/card/Card";
import classes from "./NotificationModal.module.scss";
import { IOrderReportView } from "./types";
import RbLink from "../../bosch-react/components/link/RbLink";
import RbButton, { ButtonSize, ButtonType } from "../../bosch-react/components/button/RbButton";
import Helper from "../../core/libraries/Helper";
import { LabelSize } from "../../bosch-react/components/label/RbLabel";
import Constants from "../../core/libraries/Constants";


interface IProps {
  title: string,
  message: string
  orderItems: IOrderReportView[] | null
  onRemindLater: any
  onDismissAll: any
}
export class ModalOverlay extends React.Component<IProps, any> {

  columns: any[] = [
    { field: "title", headerName: "Title", width: 48 },
    { field: "expire-date", headerName: "Expiry Date", width: 20 },
    { field: "action", headerName: "Action", width: 32 },
  ];
  render() {
    return (
      <Card className={classes.modal}>
        <header className={classes.header}>
          <h3>{this.props.title}</h3>
          <p>{this.props.message}</p>
        </header>
        <div className={classes.content}>
          <table className={classes.table}>
            <thead>
              <tr>
                {this.columns.map((col: any) => {
                  return (
                    <th key={col.field} style={{ width: `${col.width}%` }}>
                      <strong>{col.headerName}</strong>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {!!this.props.orderItems &&
                this.props.orderItems.length > 0 &&
                this.props.orderItems.map((orderItem: IOrderReportView, index: any) => {
                  return (
                    !!orderItem.isRemind && <tr key={index}>
                      <td
                        style={{
                          width: `${this.columns[0].width}%`,
                          textAlign: "left",
                        }}
                      >
                        <RbLink
                          label={orderItem.title}
                          url={Helper.generateAccessMediatorUrl(orderItem.reportId)}
                          size={LabelSize.Small}
                          shouldOpenNewTab={true}
                        />
                      </td>
                      <td
                        style={{
                          width: `${this.columns[1].width}%`,
                          textAlign: "center",
                        }}
                      >
                        {Helper.getDateTimeFormatForUI(orderItem.expiryDate)}
                      </td>
                      <td
                        style={{ width: `${this.columns[2].width}%` }}
                        className={classes.bodyActions}
                      >
                        <RbButton
                          onClick={() =>
                            Helper.openAMPage(orderItem.reportId)
                          }
                          label={orderItem.orderStatus === Constants.STATUS.EXPIRED ? "Renew" : "See document"}
                          type={orderItem.orderStatus === Constants.STATUS.EXPIRED ? ButtonType.Primary : ButtonType.Tertiary}
                          size={ButtonSize.SupperTiny}
                        ></RbButton>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <footer className={classes.actions}>
          <p className={classes.advice}>If your orders have expired, simply click the 'Renew' button to regain access to the report.</p>
          <div className={classes.buttonGroup}>
            <RbButton
              size={ButtonSize.Tiny}
              type={ButtonType.Secondary}
              label="Dismiss all"
              onClick={this.props.onDismissAll}
            ></RbButton>
            <RbButton
              size={ButtonSize.Tiny}
              onClick={this.props.onRemindLater}
              label="Remind later"
            ></RbButton>
          </div>
        </footer>
      </Card>
    );
  }
}